import { createElement } from 'react';
import { Row, Col, Progress } from 'antd';
import DataVStatistic from '../statistic';
const DataVTargetBlock = (props) => {
    const { align, icon, topTarget, progress, bottomTarget, otherTarget } = props;
    return (createElement(Row, { align: align, gutter: 8 },
        icon ? createElement(Col, null, icon) : null,
        createElement(Col, { flex: 1 },
            createElement(DataVStatistic, { ...topTarget }),
            createElement(Progress, { ...progress }),
            createElement(DataVStatistic, { ...bottomTarget }),
            otherTarget?.targets?.length ? (createElement(Row, { ...otherTarget?.row }, otherTarget?.targets?.map((item, index) => {
                return (createElement(Col, { key: index, ...item },
                    createElement(DataVStatistic, { key: index, ...item })));
            }))) : null)));
};
export default DataVTargetBlock;
